import styled from 'styled-components';

export const MenuBox = styled.div`
  margin-top: 12px;
`;

export const RoleBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 8px 0;
  > .ant-checkbox-wrapper {
    margin-right: 16px;
  }
`;
